export const contactListTableStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: '100%',
		// overflow: 'inherit',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
	},

	searchButton: {
		textTransform: 'inherit',
		width: '200px',

		svg: {
			height: '24px',
			width: '24px',

			path: {
				fill: 'var(--default-white)',
			},
		},
	},

	tableContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: 'calc(100% - 56px)',
	},

	container: {
		padding: '0',
	},

	table: {
		maxWidth: '1050px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		height: '32px !important',

		'& > :nth-of-type(1)': {
			width: '8%',
			textTransform: 'uppercase',
		},
		'& > :nth-of-type(2)': {
			width: '14%',
		},
		'& > :nth-of-type(3)': {
			width: '14%',
		},
		'& > :nth-of-type(4)': {
			textTransform: 'capitalize',
			width: '24%',
		},
		'& > :nth-of-type(5)': {
			width: '17%',
		},
		'& > :nth-of-type(6)': {
			width: '16%',
		},
		'& > :nth-of-type(7)': {
			width: '7%',
		},
	},

	tableBody: {
		'& > :nth-of-type(1)': {
			fontSize: '12px',
		},

		'& .MuiTableCell-root': {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
		},
	},

	menuItem: {
		width: '100%',
		padding: '8px 16px',
		cursor: 'pointer',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},

	deleteContactModal: {
		'.MuiPaper-root': {
			width: '100%',
			maxWidth: '770px',
			padding: '48px 200px',
		},
	},

	contactModal: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '970px',
			padding: '48px 190px 48px 200px',
			scrollbarGutter: 'stable',
			margin: '0 15px',
			borderRadius: 'var(--default--border-radius)',

			'& .MuiDialogContent-root': {
				alignItems: 'unset',
			},
		},
	},

	loader: {
		position: 'absolute',
		left: 'calc(50% - 25px)',
		top: '200px',
	},

	pagination: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginRight: '16px',
		marginTop: '12px',
	},

	stepper: {
		width: '1074px',
		margin: '40px 0',
		textTransform: 'capitalize',
		marginLeft: 'auto',
		marginRight: 'auto',

		'& .MuiTypography-root': {
			lineHeight: '28px',
		},
	},

	modal: {
		'.MuiPaper-root': {
			position: 'relative',
			minWidth: '1170px',
			width: '100%',
			maxHeight: 'calc(100% - 48px)',
			height: '100%',
			paddingTop: '48px',
			margin: '0 15px',
			borderRadius: '8px',
		},

		'&.MuiDialog-root': {
			// height: 'calc(100% - 80px)',
		},
	},

	tableCell: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		height: '48px',
	},
};
